import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getRangeValue, parseAlpha } from "./NumberUtils";
import { hslToRgb, hslaToRgba } from "./ColorUtils";
export var HslColorManager = /*#__PURE__*/function () {
  function HslColorManager() {
    _classCallCheck(this, HslColorManager);

    this.key = "hsl";
    this.stringPrefix = "hsl";
  }

  _createClass(HslColorManager, [{
    key: "handleColor",
    value: function handleColor(color) {
      var _colorValue$hsl;

      var colorValue = color.value,
          hslColor = (_colorValue$hsl = colorValue.hsl) !== null && _colorValue$hsl !== void 0 ? _colorValue$hsl : color.value;

      if (hslColor.h !== undefined && hslColor.s !== undefined && hslColor.l !== undefined) {
        return hslToRgb(hslColor);
      }
    }
  }, {
    key: "handleRangeColor",
    value: function handleRangeColor(color) {
      var _colorValue$hsl2;

      var colorValue = color.value,
          hslColor = (_colorValue$hsl2 = colorValue.hsl) !== null && _colorValue$hsl2 !== void 0 ? _colorValue$hsl2 : color.value;

      if (hslColor.h !== undefined && hslColor.l !== undefined) {
        return hslToRgb({
          h: getRangeValue(hslColor.h),
          l: getRangeValue(hslColor.l),
          s: getRangeValue(hslColor.s)
        });
      }
    }
  }, {
    key: "parseString",
    value: function parseString(input) {
      if (!input.startsWith("hsl")) {
        return;
      }

      var regex = /hsla?\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([\d.%]+)\s*)?\)/i,
          result = regex.exec(input);
      return result ? hslaToRgba({
        a: result.length > 4 ? parseAlpha(result[5]) : 1,
        h: parseInt(result[1], 10),
        l: parseInt(result[3], 10),
        s: parseInt(result[2], 10)
      }) : undefined;
    }
  }]);

  return HslColorManager;
}();